import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAgSachbearbeiterListResponseDto, IManagerProfileAuftragResponseDto } from "../types/Types";
import { PaginatorDto } from "../pages/eigeneauftraege/EigeneAuftraegeListe";

/**
 * @author mb
 */
export const AgSachbearbeiterAPI = createApi({
    reducerPath: "AgSachbearbeiterAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "agsachbearbeiter",
            credentials: 'include'
        }),
    tagTypes: ['AgSachbearbeiterAPI'], // for caching
    endpoints: (builder) => ({
        getAuftraege: builder.mutation<PaginatorDto, { offset: number, limit: number, search: string, sortBy: string, sortDirection: string }>(
            {
                query: (dto) => ({
                    url: '/auftraege',
                    method: 'post',
                    credentials: 'include',
                    body: dto
                })
            }
        ),

    })
});

export const {

    useGetAuftraegeMutation,

} = AgSachbearbeiterAPI;
